/** Copy matches digirasa-client kitchen-closed dialogs and cart snackbar. */

export const KITCHEN_CLOSED_DIALOG_TITLE = 'Kitchen Closed';

export const KITCHEN_CLOSED_DIALOG_BODY =
  'Our kitchen is currently closed. However, if you would like to place a subscription order, you can proceed to add items to your cart.';

export const KITCHEN_CLOSED_CHECKOUT_MESSAGE =
  'Kitchen is currently closed. You can subscribe for future orders.';

export const KITCHEN_OFFLINE_TITLE = 'Kitchen is offline';

const EMPTY_STATUS = {
  isStoreOpen: true,
  isManualOverrideActive: false,
  manualOverrideUntil: null,
  closureMessage: '',
  nextOpeningTime: null,
  nextClosingTime: null,
  openingTime: null,
  closingTime: null,
  timezone: 'Asia/Kolkata',
};

function asTrimmedString(value) {
  return typeof value === 'string' && value.trim() ? value.trim() : '';
}

/**
 * @param {unknown} payload
 */
export function parseStoreStatus(payload) {
  const root = payload && typeof payload === 'object' ? /** @type {Record<string, unknown>} */ (payload) : {};
  const data =
    root.data && typeof root.data === 'object' ? /** @type {Record<string, unknown>} */ (root.data) : root;

  return {
    isStoreOpen: data.is_store_open !== false,
    isManualOverrideActive: Boolean(data.is_manual_override_active),
    manualOverrideUntil: asTrimmedString(data.manual_override_until) || null,
    closureMessage: asTrimmedString(data.closure_message),
    nextOpeningTime: asTrimmedString(data.next_opening_time) || null,
    nextClosingTime: asTrimmedString(data.next_closing_time) || null,
    openingTime: asTrimmedString(data.opening_time) || null,
    closingTime: asTrimmedString(data.closing_time) || null,
    timezone: asTrimmedString(data.timezone) || 'Asia/Kolkata',
  };
}

/**
 * @param {ReturnType<typeof parseStoreStatus> | null | undefined} status
 * @param {Date} [now]
 */
export function formatKitchenReopenHint(status, now = new Date()) {
  if (!status) return '';

  const raw = status.isManualOverrideActive ? status.manualOverrideUntil : status.nextOpeningTime;
  if (!raw) return '';

  const dateTime = new Date(raw);
  if (Number.isNaN(dateTime.getTime())) return '';

  const prefix = status.isManualOverrideActive ? 'Reopens' : 'Opens';
  const diffHours = (dateTime.getTime() - now.getTime()) / (1000 * 60 * 60);

  const timeFmt = new Intl.DateTimeFormat('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const dateTimeFmt = new Intl.DateTimeFormat('en-IN', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const sameCalendarDay =
    dateTime.getDate() === now.getDate() &&
    dateTime.getMonth() === now.getMonth() &&
    dateTime.getFullYear() === now.getFullYear();

  if (diffHours < 24) {
    if (sameCalendarDay) return `${prefix} today at ${timeFmt.format(dateTime)}`;
    return `${prefix} tomorrow at ${timeFmt.format(dateTime)}`;
  }

  return `${prefix} on ${dateTimeFmt.format(dateTime)}`;
}

export function defaultStoreStatus() {
  return { ...EMPTY_STATUS };
}
